import React, { useRef } from 'react';
import cn from 'classnames'
import Webcam from 'react-webcam';
import { MainLoader } from 'components/Loader/Loader';
import './VerificationModal.sass'

interface Props {
  onHide: () => void;
  getScreen?: (value: string) => void;
  loading: boolean
}

const videoConstraints = {
  width: 720,
  height: 540,
  facingMode: 'user',
};

export const VerificationModal: React.FC<Props> = ({ onHide, getScreen, loading = true }) => {
  const webcamRef = useRef<Webcam>(null);

  const getPhoto = async () => {
    const photo = await webcamRef.current?.getScreenshot();
    if (getScreen && photo) getScreen(photo);
  };

  return (
    <div className='verification-modal' onClick={(e) => e.stopPropagation()}>
      <Webcam
        audio={false}
        width={720}
        height={'auto'}
        ref={webcamRef}
        screenshotFormat='image/jpeg'
        videoConstraints={videoConstraints}
      />
      <button disabled={loading} className={cn ('verification-modal__button', {
        'verification-modal__button--disabled': loading
      })} onClick={getPhoto}>
        {loading && <MainLoader/>}
      </button>
    </div>
  );
};
